import { isArray } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { FC, useEffect, useRef } from 'react';
import { v4 } from 'uuid';
// import cs from 'classnames';
import styles from './index.module.less';
import ReactDOM from 'react-dom';
import { showMarker } from '@/common/utils/map';

/** 商圈围栏以及默认的围栏 */
const Rail: FC<{
  mapIns: any;
  detail: any;
  isBack: boolean;
  setIsBack: (value: boolean) => void;
  rangeMarkerRef: any;
  nameMarkerVisible: boolean;
}> = ({
  mapIns,
  detail,
  isBack,
  setIsBack,
  rangeMarkerRef,
  nameMarkerVisible,
}) => {
  const circle500MarkerRef: any = useRef();
  // const circle1500MarkerRef: any = useRef();
  // const circle3000MarkerRef: any = useRef();
  const nameMarkerRef: any = useRef();

  useEffect(() => {
    methods.init();
  }, [mapIns, detail]);

  useEffect(() => {
    methods.relocationCenter();
  }, [mapIns, isBack]);

  useEffect(() => {
    if (!nameMarkerRef.current) return;
    if (nameMarkerVisible) {
      nameMarkerRef.current?.show?.();
    } else {
      nameMarkerRef.current?.hide?.();
    }
  }, [nameMarkerVisible]);

  const methods = useMethods({

    init() {
      if (!mapIns) return;
      const {
        lng,
        lat,
        polygon,
        radius,
      } = detail || {};
      if (!(+lng && +lat)) return;
      methods.createNameMarker();
      rangeMarkerRef.current.markerOf500 = methods.createCircle(500); // 5分钟步行圈
      rangeMarkerRef.current.markerOf1500 = methods.createCircle(1500); // 15分钟生活圈
      rangeMarkerRef.current.markerOf3000 = methods.createCircle(3000); // 外卖覆盖

      // 为了视图聚焦
      if (isArray(polygon) && polygon.length) {
        methods.createPolygon();
      } else if (radius > 0) {
        methods.createCircle(radius, true);
      }
    },

    /** 点击了回到商圈 */
    relocationCenter: () => {
      if (!mapIns) return;
      if (!circle500MarkerRef.current) return;
      if (isBack) {
        mapIns.setFitView(circle500MarkerRef.current, true);
        setIsBack(false);
      }
    },

    /** 绘制围栏 */
    createPolygon: () => {
      const { polygon } = detail;
      const polygonMarker = new window.AMap.Polygon({
        // path: type === SpotTypeEnum.Mall ? polygon : [],
        path: polygon,
        fillColor: '#FFA31D',
        strokeOpacity: 1,
        fillOpacity: 0.12,
        strokeColor: '#FFA31D',
        strokeWeight: 2,
        strokeStyle: 'dashed',
        strokeDasharray: [2, 2],
      });
      mapIns.add(polygonMarker);
      setTimeout(() => { // 避免无法正常缩放
        mapIns.setFitView(polygonMarker, true);
      }, 0);
    },
    /** 绘制圆形 */
    createCircle: (radius = 500, isDefault = false) => {
      const { lng, lat } = detail;
      const circleMarker = new window.AMap.Circle({
        center: [+lng, +lat],
        radius, // 半径（米）
        strokeColor: isDefault ? '#FFA31D' : '#4792FD',
        strokeWeight: isDefault ? 2 : 0.5,
        strokeOpacity: 1,
        fillOpacity: isDefault ? 0.12 : 0,
        strokeStyle: isDefault ? 'dashed' : 'solid',
        strokeDasharray: [2, 2],
        fillColor: '#FFA31D',
      });
      mapIns.add(circleMarker);
      const contentMarker = methods.createDistanceMarker(circleMarker, radius);
      if (radius === 500) {
        circle500MarkerRef.current = circleMarker;
        mapIns.setFitView(circleMarker, true);
      }
      return {
        circleMarker,
        contentMarker
      };
    },
    /** 绘制商圈名称标注 */
    createNameMarker: () => {
      // createNameMarker会执行多次
      if (nameMarkerRef.current) return;
      const uid:any = v4();
      const { lng, lat, areaName } = detail;
      const marker = new window.AMap.Marker({
        position: new window.AMap.LngLat(+lng, +lat),
        anchor: 'top-center',
        offset: [0, -34],
      });
      mapIns.add(marker); // 先添加到地图上
      marker.setContent(`<div id="${uid}"></div>`);
      ReactDOM.render(<div className={styles.textMarkerWrapper}>
        <div className={styles.textMarkerCon}>
          {areaName}
        </div>
      </div>, document.getElementById(uid));
      nameMarkerRef.current = marker;
    },

    /**
     * 不同距离围栏的标注
     *  -- 如果这里有修改，记得同时修改src/views/spotevaluation/pages/index/components/AreaDetailDrawer/components/FirstScreenRight/components/Basic.tsx文件里面的handleContentMarker
     */
    createDistanceMarker: (circleMarker, radius) => {
      let content = '';
      switch (radius) {
        case 500:
          content = '500m(5分钟步行圈)';
          break;
        case 1500:
          content = '1.5km(15分钟生活圈)';
          break;
        case 3000:
          content = '3km(外卖覆盖)';
          break;
      }
      if (!content) return;
      // 获取最顶部的经纬度
      // ps 高德文档中的circleMarker没有getPath方法，但实际是可用的
      const topPosition = circleMarker.getPath().reduce((acc, item) => {
        if (acc.lat < item.lat) {
          acc = item;
        }
        return acc;
      });
      const marker = new window.AMap.Marker({
        position: topPosition,
        offset: [0, 20]
      });
      mapIns.add(marker);

      showMarker(marker, <div className={styles.distanceHint}>
        {content}
      </div>);
      return marker;
    }
  });
  return (
    <></>
  );
};

export default Rail;

